import PrivateContainer from "../../../components/applications/chats/private";

const PrivateChat = () => {
  return <PrivateContainer />;
};

export default PrivateChat;
